<template>
	 <div class="noti">
		<div class="icon item" @click.stop="toggleNotifications" :class="{ 'active' : showNotifications && $route.name !== 'checkout', 'disabled': isUserSocialNumberMissing }">
			<i class="icons">
        <i class="alarm icon"/>
				<i class="ui blue circular label top right" v-if="subscriptions && subscriptions.length > 0 && $route.name !== 'checkout'">{{ this.subscriptions.length }}</i>
			</i>

			<transition name="fade">
				<div class="blinker-container" v-if="showBlinker">
          <span class="blinker"/>
				</div>
			</transition>
		</div>

		<transition name="fadeDown">
			<div class="notification-container" :class="subscriptions.length > 5 ? 'scrollable' : ''" v-if="showNotifications && $route.name !== 'checkout'" v-click-outside="closeNotifications">
        <i class="close icon" @click.stop="closeNotifications"/>
				<div class="notification-header">
					<div class="header" style="word-break: break-all;">
						{{ $t('components.notificationbell.header') }}
					</div>
					<div class="notices" v-if="subscriptions && subscriptions.length > 0">
						{{ subscriptions.length }} {{ $t('components.notificationbell.new') }}
					</div>
				</div>
				<div class="notifications" v-if="subscriptions && subscriptions.length > 0">
					<div class="notification" v-for="notification in subscriptions" :key="notification.id" @click="openServiceModal(notification)">
						<div class="header" style="word-break: break-all;">{{ shortString(notification.product.name, 36) }}</div>
						<div class="subtitle">{{ $t('components.notificationbell.messages.service_unset') }}</div>
					</div>
				</div>
				<div class="notifications" v-else>
					<div class="error-message">
						{{ $t('components.notificationbell.messages.no_new') }}
					</div>
				</div>
			</div>
		</transition>

     <modal ref="social_number_modal" :active="showMissingSocialNumberModal" :title="$t('modals.social_number.title')" icons="big alarm" @acceptmodal="redirectToProfilePage" @denymodal="closeSocialNumberModal">
       <h4>{{ $t('modals.social_number.header', {username: $auth.user().full_name}) }}</h4>
       <span v-html="$t('modals.social_number.body')"></span>
     </modal>

		<modal :active="showNotice" :title="$t('modals.missed_something.title')" :icons="'big alarm'" :totalnotifications="totalSubscriptions" :accept-button-disabled="!!isUserSocialNumberMissing" @acceptmodal="openNextSubscription" @denymodal="toggleBlinker">
			<h3>{{ $t('modals.missed_something.header') }}</h3>
			<span v-html="$t('modals.missed_something.body', {total: totalSubscriptions})"></span>
		</modal>

		<modal :active="almostFinished" :title="$t('modals.keep_going.title')" :icons="'big alarm'" :totalnotifications="totalSubscriptions" :accept-button-disabled="!!isUserSocialNumberMissing" @acceptmodal="openNextSubscription">
			<h3>{{ $t('modals.keep_going.header') }}</h3>
			<span v-html="$t('modals.keep_going.body', {total: totalSubscriptions})"></span>
		</modal>

		 <modal ref="overduemodal" :active="showOverdue" :title="$t('modals.overdue.title')" icons="big alarm" @acceptmodal="payOverduePayment">
			 <h3>{{ $t('modals.overdue.header') }}</h3>
       <span v-html="$t('modals.overdue.body')"></span>
       <div slot="box-actions">
         <div class="ui red basic circular button" @click="$refs.overduemodal.denyModal()">
           {{ $t('globals.buttons.cancel') }}
         </div>
         <div class="ui yellow circular button" @click="updateOverduePaymentCard()">
           {{ $t('modals.overdue.update_card') }}
         </div>
         <div class="ui blue circular button" :class="isUserSocialNumberMissing ? 'disabled' : ''" @click="$refs.overduemodal.acceptModal()">
           {{ $t('globals.buttons.pay') }}
         </div>
       </div>
		 </modal>

	</div>
</template>

<script>
	import ClickOutside from 'vue-click-outside'
	import { find, truncate } from 'lodash'

	export default {
		name: 'NotificationBell',

		data () {
			return {
				showNotificationBell: false,
				showBlinker: false,
				showNotifications: false,
				showSubscriptionModal: false,
				showWaitlistModal: false,
        showMissingSocialNumberModal: false,
				showOverdue: false,
				overdueTransactions: [],

				showNotice: false,
				almostFinished: false,

				subscriptions: [],
				subscription: null,
				totalSubscriptions: null,
        isMobile: false
			}
		},

		watch: {
			showNotifications (value) {
        const body = document.querySelector('body')
        const className = 'not-scrollable'

				if (value) {
					this.fetchNonActiveSubscriptions()

          if (this.totalSubscriptions > 5 && this.isMobile) {
            if (body.classList) {
              body.classList.add(className)
            } else {
              body.className += ' ' + className
            }
          }
				} else {
          body.classList.remove(className)
        }
			},

			showNotificationBell (value) {
				if (value && !this.showMissingSocialNumberModal) {
					this.showNotice = !this.showNotice
				}
			},

			activeMerchant () {
				this.subscriptions = []

				this.fetchNonActiveSubscriptions()
					.then(() => {
						this.toggleBlinker()
					})

				this.fetchOverdueTransactions()

        this.fetchUserMissingSocialNumber()
			},

      '$route' () {
        // this will be called any time the route changes
        if (this.$route.name === 'checkout' || this.$route.name === 'checkout_overdue_fee' || this.$route.name === 'mobile_pay_success' || this.$route.name === 'vipps_process') {
          if (this.showNotificationBell) {
            this.showNotificationBell = false
            this.showNotice = false
            this.toggleBlinker()
          }
        }
      }
		},

		mounted () {
      this.fetchNonActiveSubscriptions()

      this.fetchOverdueTransactions()

      this.fetchUserMissingSocialNumber()

      this.$events.$on('subscription-cancelled', (data) => {
        this.subscriptions = []

        this.fetchNonActiveSubscriptions()
          .then(() => {
            this.toggleBlinker()
          })
      })

      this.$events.$on('subscription-closed', (data) => {
        this.fetchNonActiveSubscriptions()
          .then(() => {
            this.toggleBlinker()
          })
      })

      this.$events.$on('updatesubscriptions', (data) => {
        this.subscriptions = []

        this.fetchNonActiveSubscriptions()
          .then(data => {
            if (data.total > 0) {
              this.almostFinished = !this.almostFinished
            } else {
              this.toggleBlinker()
            }
          })
      })

      this.$events.$on('close-overdue-modal', () => {
        if (this.showOverdue) {
          this.showOverdue = false
        }
      })

      this.checkIfMobile()
		},

		methods: {
      fetchUserMissingSocialNumber() {
        return new Promise((resolve, reject) => {
          if (this.activeMerchant) {
            this.axios.get(`merchants/${this.activeMerchant.id}/users/${this.$auth.user().id}/social-number`)
              .then(({data}) => {
                if (!data.success) {
                  this.showMissingSocialNumberModal = !this.showMissingSocialNumberModal
                }
              }).catch(error => {
              reject(error)
            })
          }
        })
      },

      redirectToProfilePage () {
        this.$router.push({name: 'profile'})
      },

      closeSocialNumberModal () {
        this.showMissingSocialNumberModal = false
      },

      payOverduePayment () {
        if (this.overdueTransactions.length > 0) {
          let transaction = this.overdueTransactions[0]

          let containerId = null
          let containerType = ''

          if (transaction.subscription_id) {
            containerId = transaction.subscription_id
            containerType = 'subscriptions'
          } else if (transaction.wait_list_subscription_id) {
            containerId = transaction.wait_list_subscription_id
            containerType = 'waitlist'
          }

          if (containerId) {
            this.$router.push({
              name: 'payoverdue',
              params: {
                id: containerId,
                type: containerType
              }
            })
          } else {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.error'),
              message: 'Something went wrong! Please try again later',
              type: 'error',
              align: 'right'
            })

            setTimeout(() => window.location.reload(), 3000)
          }
        }
      },

      updateOverduePaymentCard () {
        if (this.overdueTransactions.length > 0) {
          let transaction = this.overdueTransactions[0]
          let subscriptionId = transaction.subscription_id || transaction.wait_list_subscription_id

          if (!subscriptionId) {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.something_went_wrong'),
              message: this.$t('globals.validation.errors.try_again_later'),
              type: 'error',
              align: 'right'
            })
            return
          }

          let endpoint = transaction.subscription_id
            ? `subscriptions/${subscriptionId}`
            : `waitlistsubscriptions/${subscriptionId}`

          this.axios.get(endpoint)
            .then(({data}) => {
              let subscription = data.data || data

              if (subscription.nets_details) {
                let query = { container: 'subscription' }

                if (subscription.nets_details.subscription_id) {
                  query['subscriptionId'] = subscription.nets_details.subscription_id
                } else if (subscription.nets_details.unscheduled_subscription_id) {
                  query['unscheduled'] = true
                  query['unscheduledSubscriptionId'] = subscription.nets_details.unscheduled_subscription_id
                }

                this.showOverdue = false
                this.$router.push({
                  name: 'checkout',
                  params: { containerId: subscription.id },
                  query: query
                })
              } else {
                this.$events.$emit('alert', {
                  header: this.$t('globals.validation.errors.something_went_wrong'),
                  message: this.$t('globals.validation.errors.try_again_later'),
                  type: 'error',
                  align: 'right'
                })
              }
            })
            .catch(() => {
              this.$events.$emit('alert', {
                header: this.$t('globals.validation.errors.something_went_wrong'),
                message: this.$t('globals.validation.errors.try_again_later'),
                type: 'error',
                align: 'right'
              })
            })
        }
      },

      checkIfMobile () {
        this.isMobile = window.innerWidth <= 1200
      },

			fetchNonActiveSubscriptions () {
				return new Promise((resolve, reject) => {
					if (this.activeMerchant) {
						this.axios.get(`merchants/${this.activeMerchant.id}/subscriptions`, {
							params: {
								page: 1,
								perPage: this.isMobile ? 6 : 15,
								filter: 'unset|activating|deletable'
							}
						})
						.then(({data}) => {
							if (data.total > 0) {
								data.data.map((currentValue, index) => {
									if (!find(this.subscriptions, {id: currentValue.id})) {
                    this.subscriptions.push(currentValue)
                    currentValue.$subscription = true
									}
								})

								this.totalSubscriptions = (this.subscriptions && this.subscriptions.length > 0) ? this.subscriptions.length : 0
							}

							this.fetchNonActiveWaitListSubscriptions()
								.then(waitlistdata => {
									resolve(data, waitlistdata)
								})
						}).catch(error => {
							reject(error)
						})
					}
				})
			},

			fetchNonActiveWaitListSubscriptions () {
				return new Promise((resolve, reject) => {
					if (this.activeMerchant) {
						this.axios.get(`merchants/${this.activeMerchant.id}/waitlistsubscriptions`, {
							params: {
								page: 1,
								perPage: this.isMobile ? 6 : 15,
								filter: 'unset|deletable'
							}
						})
						.then(({data}) => {
							if (data.total > 0) {
								data.data.map((currentValue, index) => {
									if (!find(this.subscriptions, {id: currentValue.id})) {
										currentValue.$waitlist = true
										this.subscriptions.push(currentValue)
									}
								})

								this.totalSubscriptions = (this.subscriptions && this.subscriptions.length > 0) ? this.subscriptions.length : 0
							}

							this.showNotificationBell = this.subscriptions && this.subscriptions.length > 0 && (this.$route.name !== 'checkout' && this.$route.name !== 'checkout_overdue_fee' && this.$route.name !== 'mobile_pay_success' && this.$route.name !== 'vipps_process')
							resolve(data)
						}).catch(error => {
							reject(error)
						})
					}
				})
			},

			openServiceModal (service) {
        if (this.safeObjectGet(service, 'product.waitlist') || service.$waitlist) {
          this.axios.get(`waitlistsubscriptions/${service.id}`)
            .then(({data}) => {
              this.subscription = data
              this.showNotifications = false
              data.$waitlist = true
              this.$nextTick(() => {
                this.$events.fire('OpenNewSubscription', data)
              })
            }).catch()
        } else if (this.safeObjectGet(service, 'product.subscription') || service.$subscription) {
          this.axios.get(`subscriptions/${service.id}`)
            .then(({data}) => {
              this.subscription = data
              this.showNotifications = false
              data.$subscription = true
              this.$nextTick(() => {
                this.$events.fire('OpenNewSubscription', data)
              })
            }).catch()
        }
			},

			closeNotifications () {
				if (this.showNotifications) {
					this.showNotifications = false

					this.toggleBlinker()
				}
			},

			toggleBlinker () {
				if (!this.showNotifications) {
					this.showBlinker = this.showNotificationBell
				} else {
					this.showBlinker = false
				}
			},

			toggleNotifications () {
        if (this.isUserSocialNumberMissing) {
          this.showNotifications = false
          return false
        } else {
          if (this.showNotifications) {
            this.showNotifications = false

            this.toggleBlinker()
          } else {
            this.showNotifications = true
            this.showBlinker = false
          }
        }
			},

			openNextSubscription () {
				if (this.subscriptions.length > 0) {
					this.openServiceModal(this.subscriptions[0])
				}
			},

			shortString (longString, length = 120) {
				return truncate(longString, {
					length
				})
			},

			fetchOverdueTransactions () {
        if (this.activeMerchant) {
          this.axios.get(`merchants/me/${this.activeMerchant.id}/transactions`, {
            params: {
              perPage: 150,
              status: ['overdue']
            }
          })
            .then(({data}) => {
              if (data.total > 0) {
                let filteredOverdueTransactions = data.data.filter(function(item) {
                  return !item.subscriptionInactive && !item.waitlistInactive
                })

                if (filteredOverdueTransactions.length > 0) {
                  if (this.$route.name !== 'checkout' && this.$route.name !== 'checkout_overdue_fee' && this.$route.name !== 'mobile_pay_success' && this.$route.name !== 'vipps_process') {
                    this.showOverdue = true
                  }
                }
              }
              this.overdueTransactions = data.data
            })
            .catch()
        }
			},

			openOverdueSubscription () {
				if (this.overdueTransactions && this.overdueTransactions.length > 0) {
					const service = {
						product: {}
					}

					if (this.overdueTransactions[0].subscription_id) {
						service.id = this.overdueTransactions[0].subscription_id
						service.product.type = 'subscription'
					} else if (this.overdueTransactions[0].wait_list_subscription_id) {
						service.id = this.overdueTransactions[0].wait_list_subscription_id
						service.product.type = 'wait_list'
					}

					this.$nextTick(() => {
						this.openServiceModal(service)
					})
				}
			}
		},

		computed: {
			activeMerchant () {
				return this.$store.getters.activeMerchant
			},

      isUserSocialNumberMissing() {
        return this.activeMerchant && this.activeMerchant.opus && !this.$auth.user().social_number
      }
		},

		directives: {
			ClickOutside
		},

		beforeDestroy () {
			this.$events.$off('subscription-cancelled')
			this.$events.$off('subscription-closed')
			this.$events.$off('updatesubscriptions')
		}
	}
</script>

<style lang="scss" scoped>
	.noti {
		position: relative;
		.icon {
			&:before {
				right: auto;
				left: 0;
			}

			>.icons {
				>.top.right.label {
					position: absolute;
					top: -6px;
					right: -6px;
					font-size: 8px;
				}
			}
		}
	}

  .scrollable {
    justify-content: flex-start !important;
    width: 330px;
    height: 450px !important;
    overflow-y: scroll !important;
  }
	.notification-container	{
		position: absolute;
		width: 300px;
    overflow-x: hidden;
    overflow-y: hidden;
		background: #fff;
		top: 100%;
		right: 0;
		margin: .5em 0;
		z-index: 1000;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-flow: column;
		border-radius: .28571429rem;
		cursor: auto;

		@media screen and (max-width: 768px) {
			position: fixed;
			top: auto;
			margin: .5em;
			box-shadow: 0 5px 20px black;
			width: calc(100vw - 1em);
      height: auto;
      overflow-y: hidden;
		}

		i.close.icon {
			position: absolute;
			top: 0;
			right: 0;
			margin: 2px;
			color: rgba(0,0,0,.2);

			&:hover {
				color: rgba(0,0,0,.5);
				cursor: pointer;
			}
		}

		.notification-header {
			background: #f39c20;
			padding: 20px;
			width: 100%;
			display: flex;
			flex-flow: row;
			justify-content: space-between;
			align-items: center;
		}

		.notifications {
			display: flex;
			align-items: center;
			justify-content: center;
			flex-flow: column;
			text-align: left;
			width: 100%;

			.error-message {
				font-weight: 700;
				font-size: 1.28571429rem;
				padding: 1rem;
				width: 100%;
			}

			.notification {
				width: 100%;
				display: flex;
				flex-flow: column;
				padding: 1rem;
				border-bottom: 1px solid rgba(34,36,38,.05);

				&:last-child {
					border-bottom: 0;
				}

				&:hover {
					background: #f1f1f1;
					cursor: pointer;
				}

				.header {
					align-self: flex-start;
					font-weight: 700;
					font-size: 1.28571429rem;
					margin-bottom: 0.6rem;
				}

				.subtitle {
					font-size: 1rem;
				}
			}
		}
	}

	.blinker-container {
		position: absolute;
		display: flex;
		justify-content: center;
		align-items: center;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;

		.blinker {
			position: relative;
			width: 40px;
			height: 40px;
			background: rgba(0,0,0,.2);
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			animation: pulse 1s infinite;
			animation-direction: both;

			&:before {
				content: "";
				position: relative;
				width: 40px;
				height: 40px;
				background: rgba(0,0,0,.2);
				border-radius: 50%;
				animation-name: blink;
				animation-duration: 1s;
				animation-iteration-count: infinite;
			}
		}
	}

	@keyframes blink {
		from {
			opacity: 1;
			transform: scale(1);
		}
		to {
			transform: scale(2);
			opacity: 0;
		}
	}

	.fadeDown-enter-active,
	.fadeDown-leave-active {
		transform: translateY(0);
		transition: all .15s ease;
	}
	.fadeDown-enter,
	.fadeDown-leave-to {
		transform: translateY(-10%);
		opacity: 0
	}
</style>



// WEBPACK FOOTER //
// src/components/notifications/NotificationBell.vue